import {Injectable} from 'ng-metadata/core';
import {getVid} from '../../../appConfig/appConfigForward';
import {MappingTablesCache} from '../../../mappingTablesCache/mappingTablesCache.service';

@Injectable()
export class AuthoritySearchBarService {

    private _searchBarInput: string;
    private _selectedScope;
    private _selectedOperator: string;
    public SEARCH_FIELD_SCOPES :string[];
    public SEARCH_OPERATOR_OPTIONS: {code: string, name: string}[];


    constructor(private mappingTablesCache : MappingTablesCache){
        this.SEARCH_FIELD_SCOPES = this.authoritySearchScopesList;
        this.SEARCH_OPERATOR_OPTIONS = this.buildOperatorOptions();
        if (this.SEARCH_OPERATOR_OPTIONS.length > 0) {
            this._selectedOperator = this.SEARCH_OPERATOR_OPTIONS[0].code;
        }
    }

    public get searchBarInput(): string{
        return this._searchBarInput;
    }

    public set searchBarInput(newSearchInput: string){
        this._searchBarInput= newSearchInput;
    }

    public get selectedScope(){
        return this._selectedScope;
    }

    public set selectedScope(newScope){
        this._selectedScope= newScope;
    }

    public get selectedOperator(): string {
        return this._selectedOperator;
    }

    public set selectedOperator(newOperator: string) {
        this._selectedOperator = newOperator;
    }

    public get hasMultipleOperators(): boolean {
        return this.SEARCH_OPERATOR_OPTIONS.length > 1;
    }

    private buildOperatorOptions(): {code: string, name: string}[] {
        let allRows = this.mappingTablesCache.getTable(this.mappingTablesCache.tables.AUTHORITY_SEARCH_OPERATORS) || [];
        return allRows.map(row => ({code: row.target, name: row.source1}));
    }

    private get authoritySearchScopesList() {
        return this.authoritySearchScopesObjFromConf.map(mt => mt.target);
    }

    private get authoritySearchScopesObjFromConf() {
        return this.mappingTablesCache.findByProperties(this.mappingTablesCache.tables.AUTHORITY_SEARCH_SCOPES,
            {source1: getVid()});
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/components/search/authority/authoritySearchBar/authoritySearchBar.service.ts